import React from 'react';
import { useLocation } from 'react-router-dom';
import ClassView from './ClassView';
import ClassEdit from './ClassEdit';
import DashboardScreen from './DashboardScreen';

const ClassRouteWrapper = ({ isEdit = false }) => {
  const location = useLocation();
  const classData = location.state?.classData;

  return (
    <DashboardScreen>
      {isEdit ? <ClassEdit classData={classData} /> : <ClassView classData={classData} />}
    </DashboardScreen>
  );
};

export default ClassRouteWrapper;
